import { render } from "./Opteller.vue?vue&type=template&id=7d6981d6"
import script from "./Opteller.vue?vue&type=script&lang=js"
export * from "./Opteller.vue?vue&type=script&lang=js"

import exportComponent from "C:\\__MRYNK\\_2022\\beweegminuut\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__